import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import AiUsageIndicator from 'modules/ai/components/AiUsageIndicator';
import { useSocietyAiAgentPage } from '../context/SocietyAiAgentPageContext';
import { AiConversationSummary } from '../types/SocietyAiAgentPageContextType';
import NaviOrb from './NaviOrb';

const ConversationSidebar: FC = () => {
  const { t } = useTranslate();
  const { societyId } = useParams<{ societyId: string }>();
  const { data, actions } = useSocietyAiAgentPage();

  return (
    <aside className="navi-sidebar">
      <div className="navi-sidebar__header">
        <div className="navi-sidebar__brand">
          <NaviOrb size={24} showSparkles={false} />
          <span className="navi-sidebar__brand-name">Navi</span>
        </div>
        <button
          type="button"
          className="navi-sidebar__new-btn"
          onClick={actions.handleResetConversation}
          title={t('CHATBOT_NewChat')}
        >
          <em className="icon ni ni-edit" />
        </button>
      </div>

      {societyId && (
        <div className="navi-sidebar__usage">
          <AiUsageIndicator societyId={societyId} />
        </div>
      )}

      <div className="navi-sidebar__section-label">
        {t('CHATBOT_Conversations')}
      </div>

      <nav className="navi-sidebar__list">
        {data.conversations.length === 0 ? (
          <p className="navi-sidebar__empty">{t('CHATBOT_NoConversations')}</p>
        ) : (
          data.conversations.map((conv: AiConversationSummary) => (
            <button
              key={conv.id}
              type="button"
              className={`navi-sidebar__item${
                data.activeConversationId === conv.id
                  ? ' navi-sidebar__item--active'
                  : ''
              }`}
              onClick={() => actions.handleSelectConversation(conv.id)}
            >
              <em className="icon ni ni-chat navi-sidebar__item-icon" />
              <span className="navi-sidebar__item-title">{conv.title}</span>
            </button>
          ))
        )}
      </nav>
    </aside>
  );
};

export default ConversationSidebar;
